import AddressFrom from './address-form';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  CHANGE_ADDRESS_OR_MOBILE: AddressFrom,
};
